module.exports = {"agenda":{"condition":["manager"]}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json-resources/visibility-configs.json
// module id = vwI0
// module chunks = 0